import ScalarIconGitBranch_vue_vue_type_script_setup_true_lang_default from "./ScalarIconGitBranch.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconGitBranch.vue
var ScalarIconGitBranch_default = ScalarIconGitBranch_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconGitBranch_default as default };

//# sourceMappingURL=ScalarIconGitBranch.js.map